export default "__VITE_ASSET__zlHdEoZD__"